module.exports = __webpack_public_path__ + "static/media/partners-main.98382405.png";